import React from "react";
import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = ({ text = "جاري التحميل..." }) => (
  <div className={styles.wrapper}>
    <div className={styles.spinner} />
    <span>{text}</span>
  </div>
);

export default LoadingSpinner;